import useEmblaCarousel from "embla-carousel-react";
import { useCallback, useEffect, useState } from "react";
import { usePlosTranslations } from "../../contexts/PlosTranslationsContext";
import { PagerButton } from "../buttons/PagerButton";
import { SurfaceContainer } from "../SurfaceContainer";
import {
  buttonsContainer,
  carouselScrollContainer,
  carouselViewport,
  headingContainer,
} from "./carouselPanel.css";
import { CarouselPanelProps } from "./types";

const CarouselPanel = ({
  title,
  children,
  initialItemIndex = 0,
}: CarouselPanelProps) => {
  const { carouselPanel: defaults } = usePlosTranslations();
  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);

  const [emblaRef, emblaApi] = useEmblaCarousel({
    startIndex: initialItemIndex,
    align: "start",
    loop: true,
    duration: 15,
  });

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);
  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  const checkCanScroll = useCallback(() => {
    if (emblaApi) {
      const canScrollNext = emblaApi.canScrollNext();
      const canScrollPrev = emblaApi.canScrollPrev();
      setCanScrollNext(canScrollNext);
      setCanScrollPrev(canScrollPrev);
    }
  }, [emblaApi]);

  useEffect(() => {
    if (emblaApi) {
      checkCanScroll();
      emblaApi.on("resize", checkCanScroll);
      emblaApi.on("select", checkCanScroll);
    }
  }, [emblaApi, checkCanScroll]);

  return (
    <SurfaceContainer>
      <div className={headingContainer}>
        <h2>{title}</h2>
        <div className={buttonsContainer}>
          <PagerButton
            onPress={scrollPrev}
            label={defaults.scrollLeft}
            direction="left"
            isDisabled={!canScrollPrev}
          />
          <PagerButton
            onPress={scrollNext}
            label={defaults.scrollRight}
            direction="right"
            isDisabled={!canScrollNext}
          />
        </div>
      </div>
      <div className={carouselViewport} ref={emblaRef}>
        <div className={carouselScrollContainer}>{children}</div>
      </div>
    </SurfaceContainer>
  );
};

export default CarouselPanel;
